<template>
  <div class="multi-modify choosed-nav">
    <van-cell >
      <template #title>
        <span 
          @click="$router.back()" 
          style="color: var(--c1);" 
          data-test="multi-modify-btn-back-choose">返回选择</span>
      </template>
      <template>
        <div style="color: var(--g6); text-align: center;">
          已选<span  style="color: var(--c1);">{{len}}</span>{{multiEditClass?'个班级': '节课'}}
        </div>
      </template>
    </van-cell>
  </div>
</template>

<script>
export default {
  props: {
    len: {
      type: Number,
      default: 0,
    },    
    multiEditClass: {
      type: Boolean,
      default: false,
    },

  }
}
</script>

<style lang="scss" scoped>
.multi-modify.choosed-nav{

  height: 48px;
  background: var(--white);
  border-bottom: 1px solid var(--g3);
  overflow: hidden;
  >div{
    padding: 12px 16px;
    .van-cell__title{
      width: auto;
      flex: unset;
    }
  }

}
</style>